import { SummaryLabel, TargetTotalWrapper } from './common';

interface TargetsTotalSummaryData {
  millTotal: number; // Total Mill annual target value
  millTotalUnit: string | null; // Total Mill annual target unit
  baselineTotal: number; // Total Baseline value
  baselineTotalUnit: string | null; // Total Baseline unit
  metrics: TargetsTotalMetricData[]; // Array of individual metric data
}

interface TargetsTotalMetricData {
  metricType: string; // Type of metric
  millAnnualTarget: number; // Mill annual target value
  baseline: number; // Baseline value
  unit: string | null; // Unit
}

// Metrics to display as columns in the table
const METRICS_TO_DISPLAY = ['Electricity', 'Heat', 'Diesel for transportation', 'HVO'];

// Properties to display as rows in the table
const PROPERTIES_TO_DISPLAY = [
  { label: 'Mill annual target', property: 'millAnnualTarget' },
  { label: 'Baseline', property: 'baseline' },
];

function TargetTotalSummary({ data }: { data: TargetsTotalSummaryData }) {
  // Function to find the corresponding metric data based on the metric type
  const findMetricData = (metricType: string): TargetsTotalMetricData | undefined => {
    return data?.metrics?.find((metric: TargetsTotalMetricData) => metric.metricType === metricType);
  };

  return (
    <TargetTotalWrapper>
      <div>
        <SummaryLabel style={{ fontWeight: 'bold', fontSize: '1.2em' }}>Total Mill annual target:</SummaryLabel>{' '}
        <span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>
          {data?.millTotal} {data?.millTotalUnit ?? ''}
        </span>
      </div>
      <br />
      <div>
        <SummaryLabel style={{ fontWeight: 'bold', fontSize: '1.2em' }}>Total Baseline:</SummaryLabel>{' '}
        <span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>
          {data?.baselineTotal} {data?.baselineTotalUnit ?? ''}
        </span>
      </div>
      <br />
      <table
        style={{
          marginTop: '20px',
          borderSpacing: '0',
          borderCollapse: 'collapse',
          width: '100%',
          border: '1px solid black',
        }}
      >
        <colgroup>
          <col style={{ minWidth: '200px' }} />
          {METRICS_TO_DISPLAY.map((_, index) => (
            <col key={index} style={{ minWidth: '200px' }} />
          ))}
        </colgroup>
        <thead>
          <tr style={{ backgroundColor: '#dadada' }}>
            <th style={{ border: '1px solid black', padding: '10px', textAlign: 'center' }}></th>
            {/* Render table headers for each metric */}
            {METRICS_TO_DISPLAY.map((metric) => (
              <th
                key={metric}
                style={{ border: '1px solid black', padding: '10px', textAlign: 'center', whiteSpace: 'nowrap' }}
              >
                {metric}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {/* Render table rows for each property */}
          {PROPERTIES_TO_DISPLAY.map(({ label, property }) => (
            <tr key={property} style={{ backgroundColor: '#ffffff' }}>
              <td style={{ border: '1px solid black', padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>
                {label}
              </td>
              {/* Render table data for each metric and property */}
              {METRICS_TO_DISPLAY.map((metric) => {
                const metricData = findMetricData(metric);
                return (
                  <td
                    key={metric}
                    style={{ border: '1px solid black', padding: '10px', textAlign: 'right', whiteSpace: 'nowrap' }}
                  >
                    {metricData
                      ? `${metricData[property as keyof TargetsTotalMetricData]} ${metricData.unit ?? ''}`
                      : '0'}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </TargetTotalWrapper>
  );
}

export default TargetTotalSummary;
